import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { expiredCokkieInDay } from "../../utils/storageItems";
import { useNavigate, useSearchParams } from "react-router-dom";

const JwtComponent = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const decodedToken = searchParams.get("token");
    const decodedRefreshToken = searchParams.get("refreshtoken");

    const encodedToken = encodeURIComponent(decodedToken || "");
    const encodedRefreshToken = encodeURIComponent(decodedRefreshToken || "");

    const fetchData = async (encodedToken: string, encodedRefreshToken: string) => {
        try {
            if (encodedToken && encodedRefreshToken) {
                Cookies.set("token", encodedToken, { expires: expiredCokkieInDay });
                Cookies.set("refreshToken", encodedRefreshToken, { expires: expiredCokkieInDay });
            }

        } catch (error) {
            if (error) console.error('Error');
        }
    }

    useEffect(() => {
        if (encodedToken && encodedRefreshToken) {
            fetchData(encodedToken, encodedRefreshToken);
            navigate("/");
        }
        console.log("Encoded Token:", encodedToken);
        console.log("Encoded Refresh Token:", encodedRefreshToken);
    }, []);
    return (<div></div>)
}

export default JwtComponent;